module.exports = __webpack_public_path__ + "img/brand-04.359b43aa.png";